import classNames from 'classnames';
import styles from './MissingImage.module.css';

//#region [Props]
type MissingImageProps = {
	missingText?: string;
	aspect: string;
	className?: string;
};
//#endregion

//#region [Component]
export default function MissingImage({ missingText = "Bilde mangler", aspect, className }: MissingImageProps) {
	return <div style={{ aspectRatio: aspect }} className={classNames(styles.SMissingImage, className)}>
		<svg className={styles.SMissingSvg} viewBox="0 0 200 20">
			<text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle">{missingText}</text>
		</svg>
	</div>;
}
//#endregion